import React, { createContext, useRef, useContext, useState } from 'react'

const VideoPlayerContext = createContext()

export const VideoPlayerProvider = ({ children }) => {
  const videoRef = useRef(null)
  const [isVideoMaximized, setIsVideoMaximized] = useState(false)

  const changeVideoPlaybackRate = (speed) => {
    if (videoRef.current) {
      videoRef.current.playbackRate = speed
    }
  }

  const jumpVideoTo = (time) => {
    if (videoRef.current) {
      videoRef.current.currentTime = time
    }
  }

  const playVideo = () => {
    if (videoRef.current) {
      videoRef.current.play()
    }
  }

  const pauseVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause()
    }
  }

  const toggleFullScreen = () => {
    if (videoRef.current && videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen()
    }
  }

  const togglePip = () => {
    if (document.pictureInPictureElement) {
      try {
        document.exitPictureInPicture()
      } catch (err) {
        console.info(err)
      }
    } else if (videoRef.current && videoRef.current.requestPictureInPicture) {
      videoRef.current.requestPictureInPicture()
      setIsVideoMaximized(false)
    }
  }

  const toggleVideoMaximized = () => {
    setIsVideoMaximized((prev) => !prev)
  }

  const addVideoEvent = (eventType, callback) => {
    if (videoRef.current) {
      videoRef.current.addEventListener(eventType, callback)
    }
  }

  const removeVideoEvent = (eventType, callback) => {
    if (videoRef.current) {
      videoRef.current.removeEventListener(eventType, callback)
    }
  }

  return (
    <VideoPlayerContext.Provider
      value={{
        videoRef,
        changeVideoPlaybackRate,
        jumpVideoTo,
        playVideo,
        pauseVideo,
        toggleFullScreen,
        togglePip,
        toggleVideoMaximized,
        isVideoMaximized,
        addVideoEvent,
        removeVideoEvent,
      }}
    >
      {children}
    </VideoPlayerContext.Provider>
  )
}

export const useVideoPlayer = () => {
  return useContext(VideoPlayerContext)
}
